import io from 'socket.io-client'
import config from '../lib/config'
export const socket = io.connect(`${config.Back_Url}/`)